const finelfApi = {
  apiUrl: 'https://finsales-pl.finelf.com/api/v1',
  dataUri: '/send_lead/a50bed41-534e-418e-a9c6-a6c7102e4cb6/', // #MILOAN
  // dataUri: '/send_lead/286af1f3-a01c-44ef-a2ed-db375176556e/', DEBUG
  agreements: '/agreements',
};

export default finelfApi;
